
import React from "react";
import { CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";

interface FormHeaderProps {
  currentStep: number;
}

export function FormHeader({ currentStep }: FormHeaderProps) {
  return (
    <CardHeader>
      <CardTitle className="text-2xl text-center">Join Our Expert Marketplace</CardTitle>
      <div className="text-center space-y-2">
        <p className="text-gray-600">
          Apply to join our vetted Expert Marketplace — where families seek guidance from trusted professionals on navigating aged care, Fair Deal, emergency placements, and more.
        </p>
        <p className="text-sm text-gray-500">
          Experts set their own rates and schedule, and get matched directly with families in need.
        </p>
      </div>
      
      {/* Progress Indicator */}
      <div className="flex items-center justify-center mt-6 space-x-2">
        <div className={`flex items-center space-x-2 ${currentStep >= 1 ? 'text-grandpal-green' : 'text-gray-400'}`}>
          <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${currentStep >= 1 ? 'border-grandpal-green bg-grandpal-green text-white' : 'border-gray-300'}`}>
            {currentStep > 1 ? <CheckCircle className="w-4 h-4" /> : '1'}
          </div>
          <span className="text-xs font-medium">Personal</span>
        </div>
        <div className={`w-4 h-px ${currentStep >= 2 ? 'bg-grandpal-green' : 'bg-gray-300'}`} />
        <div className={`flex items-center space-x-2 ${currentStep >= 2 ? 'text-grandpal-green' : 'text-gray-400'}`}>
          <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${currentStep >= 2 ? 'border-grandpal-green bg-grandpal-green text-white' : 'border-gray-300'}`}>
            {currentStep > 2 ? <CheckCircle className="w-4 h-4" /> : '2'}
          </div>
          <span className="text-xs font-medium">Experience</span>
        </div>
        <div className={`w-4 h-px ${currentStep >= 3 ? 'bg-grandpal-green' : 'bg-gray-300'}`} />
        <div className={`flex items-center space-x-2 ${currentStep >= 3 ? 'text-grandpal-green' : 'text-gray-400'}`}>
          <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${currentStep >= 3 ? 'border-grandpal-green bg-grandpal-green text-white' : 'border-gray-300'}`}>
            {currentStep > 3 ? <CheckCircle className="w-4 h-4" /> : '3'}
          </div>
          <span className="text-xs font-medium">Experience</span>
        </div>
        <div className={`w-4 h-px ${currentStep >= 4 ? 'bg-grandpal-green' : 'bg-gray-300'}`} />
        <div className={`flex items-center space-x-2 ${currentStep >= 4 ? 'text-grandpal-green' : 'text-gray-400'}`}>
          <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${currentStep >= 4 ? 'border-grandpal-green bg-grandpal-green text-white' : 'border-gray-300'}`}>
            {currentStep > 4 ? <CheckCircle className="w-4 h-4" /> : '4'}
          </div>
          <span className="text-xs font-medium">Pricing</span>
        </div>
      </div>
    </CardHeader>
  );
}
